export default __webpack_public_path__ + "images/150e8c7066bcc7d2d4626655978ac77a.svg";